import { FlatList, View } from 'react-native';

import { GridList } from '@/components/_shared/GridList';
import { Skeleton } from '@/components/_shared/Skeleton';
import { useLaunchDarklyFlag } from '@/hooks/flags/useLaunchDarklyFlag';
import { getServiceGridColumns } from '@/utils/booking/getServiceGridColumns';

import { styles } from './styles';
import type { ChooseProfessionalSkeletonProps } from './types';

const skeletonCount = 6;
const skeletonData = new Array(skeletonCount).fill(null);

const ProfessionalCardSkeleton = ({ testID }: { testID?: string }) => (
  <View style={styles.cardContainer} testID={testID}>
    <Skeleton variant="rectangular" width={64} height={64} />
    <Skeleton variant="text" width="80%" height={16} />
    <View style={styles.separatorSkeleton} />
    <Skeleton variant="text" width="60%" height={14} />
  </View>
);

const ProfessionalCardSkeletonV2 = ({ testID }: { testID?: string }) => (
  <View style={styles.listCardContainer} testID={testID}>
    <Skeleton variant="rectangular" width={64} height={64} />
    <View style={styles.listCardContent}>
      <Skeleton variant="text" width="60%" height={16} />
      <Skeleton variant="text" width="80%" height={12} />
    </View>
  </View>
);

export const ChooseProfessionalSkeleton = ({
  testID,
  isListView: isListViewProp,
}: ChooseProfessionalSkeletonProps) => {
  const isListViewFlag = useLaunchDarklyFlag(
    'expo-booking-flow-list-view',
    false,
  );
  const isListView = isListViewProp ?? isListViewFlag;

  if (isListView) {
    return (
      <FlatList
        testID={testID}
        data={skeletonData}
        contentContainerStyle={styles.listContentContainer}
        showsVerticalScrollIndicator={false}
        renderItem={({ index }) => (
          <ProfessionalCardSkeletonV2
            testID={`professional-skeleton-${index}`}
          />
        )}
      />
    );
  }

  return (
    <GridList
      testID={testID}
      data={skeletonData}
      itemStyle={styles.gridItem}
      columnWrapperStyle={styles.columnGrid}
      contentContainerStyle={styles.rowGrid}
      showsVerticalScrollIndicator={false}
      renderItem={({ index }) => (
        <ProfessionalCardSkeleton testID={`professional-skeleton-${index}`} />
      )}
      getColumns={getServiceGridColumns}
    />
  );
};
